import { FormatCurrencyOptions } from "./types";

export const HIDE_DECIMAL: FormatCurrencyOptions = {
  maximumFractionDigits: 0,
  minimumFractionDigits: 0,
};

export const ABBREVIATED_OPTION: FormatCurrencyOptions = {
  abbreviate: true,
};

export const ABBREVIATED_OPTION_HIDE_DECIMAL: FormatCurrencyOptions = {
  abbreviate: true,
  maximumFractionDigits: 0,
  minimumFractionDigits: 0,
  style: "currency",
};

export const NO_SYMBOL: FormatCurrencyOptions = {
  style: "decimal",
};
